import {
  RESET_AVAILABILITY,
  CREATE_AVAILABILITY,
  CREATED_AVAILABILITY,
  GET_AVAILABILITIES,
  SET_AVAILABILITIES,
  API_ERROR,
  GET_AVAILABILITY,
  SET_AVAILABILITY,
  EDIT_AVAILABILITY,
  EDIT_AVAILABILITY_SUCCESS,
  DELETE_AVAILABILITY,
  DELETE_AVAILABILITY_SUCCESS,
  UPDATE_AVAILABILITY,
  UPDATE_AVAILABILITY_SUCCESS,
  UPDATE_AVAILABILITY_AGENT,
  UPDATE_AVAILABILITY_AGENT_SUCCESS,
  UPDATE_AVAILABILITY_SIGNALR,
  UPDATE_AVAILABILITY_SIGNALR_SUCCESS,
  RESET_UPDATE_AGENT,
  RESET_AVAILABILITIES,
  RESET_ERROR,
  API_ERROR_CRUD,
  REVALIDATE_AVAILABILITY,
} from "./actionTypes";

export const resetAvailability = () => {
  return {
    type: RESET_AVAILABILITY,
    payload: {},
  };
};

export const resetAvailabilities = () => {
  return {
    type: RESET_AVAILABILITIES,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getAvailabilities = (page, qnt, name) => {
  return {
    type: GET_AVAILABILITIES,
    payload: { page, qnt, name },
  };
};

export const loadAvailabilities = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);
  return {
    type: SET_AVAILABILITIES,
    payload: { ...data, paging },
  };
};

export const apiErrorCRUD = (error) => {
  return {
    type: API_ERROR_CRUD,
    payload: error,
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createAvailability = (newFields) => {
  return {
    type: CREATE_AVAILABILITY,
    payload: { newFields },
  };
};
export const createdAvailability = (message) => {
  return {
    type: CREATED_AVAILABILITY,
    payload: { message },
  };
};

export const getAvailability = (idAvailability) => {
  return {
    type: GET_AVAILABILITY,
    payload: { idAvailability },
  };
};
export const setAvailability = (data) => {
  return {
    type: SET_AVAILABILITY,
    payload: { data },
  };
};

export const editAvailability = (idAvailability, newFields) => {
  return {
    type: EDIT_AVAILABILITY,
    payload: { idAvailability, newFields },
  };
};

export const editAvailabilitySuccess = (message) => {
  return {
    type: EDIT_AVAILABILITY_SUCCESS,
    payload: { message },
  };
};

export const deleteAvailability = (availId) => {
  return {
    type: DELETE_AVAILABILITY,
    payload: { availId },
  };
};
export const deleteAvailabilitySuccess = (message) => {
  return {
    type: DELETE_AVAILABILITY_SUCCESS,
    payload: { message },
  };
};

export const updateAvailability = (availId, availName) => {
  return {
    type: UPDATE_AVAILABILITY,
    payload: { availId, availName },
  };
};

export const updateAvailabilitySuccess = (message, availId) => {
  return {
    type: UPDATE_AVAILABILITY_SUCCESS,
    payload: { message, availId },
  };
};

export const updateAvailabilityAgent = (availId, agentId) => {
  return {
    type: UPDATE_AVAILABILITY_AGENT,
    payload: { availId, agentId },
  };
}

export const updateAvailabilityAgentSuccess = (message) => {
  return {
    type: UPDATE_AVAILABILITY_AGENT_SUCCESS,
    payload: { message },
  };
};

export const updateAvailabilitySignalr = (status, message, availId) => {
  return {
    type: UPDATE_AVAILABILITY_SIGNALR,
    payload: { status, message, availId },
  };
}

export const updateAvailabilitySignalrSuccess = (message, availId) => {
  return {
    type: UPDATE_AVAILABILITY_SIGNALR_SUCCESS,
    payload: { message, availId },
  };
};

export const resetUpdateAgent = () => {
  return {
    type: RESET_UPDATE_AGENT,
    payload: {},
  }
}

export const revalidateAvailability = (availId) => {
  return {
    type: REVALIDATE_AVAILABILITY,
    payload: { availId },
  }
}